export default __webpack_public_path__ + "static/media/moneyhash_fawry.536ae9b5.svg";